// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3qwWi","select":"Header_select__3hTqm","clinic":"Header_clinic__3-UQ8"};